





































import { Component, Mixins } from 'vue-property-decorator';
import { Popup, Tab, Tabs } from 'vant';
import Dialog from '@/mixins/Dialog';
import ReceiveRecordList from './ReceiveRecordList.vue';
import MyAwardList from './MyAwardList.vue';
import Box from '@/components/Box.vue';

@Component({
    components: {
        'van-popup': Popup,
        'van-tab': Tab,
        'van-tabs': Tabs,
        'receive-record-list': ReceiveRecordList,
        'my-award-list': MyAwardList,
        'box': Box
    }
})
export default class RecordDialog extends Mixins(Dialog) {
    public active: number = 0;

    //打开弹窗
    public open(): void {
        this.show = true;
        this.$nextTick(() => {
            let my_award_list = (this.$refs.my_award_list as MyAwardList);
            (this.$refs.receive_record_list as ReceiveRecordList).clear();
            (this.$refs.receive_record_list as ReceiveRecordList).fetchList();
            my_award_list.clear();
            my_award_list.fetchList();
        });
    }
}
